<div class="flex items-center gap-5">
  <div class="flex w-[392px] flex-col items-center">
    <div class="text-[24px]/[32px] font-medium text-text-primary">{{ 'ffd_notes_login_modal_title' | translate }}</div>
    <div class="gradient-text text-[24px]/[32px] font-medium text-text-primary">
      {{ 'ffd_notes_login_modal_gradient_title' | translate }}
    </div>
    <div class="mb-5 mt-1 text-[16px]/[24px] font-normal text-text-secondary">{{ 'ffd_notes_login_modal_subtitle' | translate }}</div>
    <qrcode
      [qrdata]="'express_notes_app_url' | translate"
      [width]="qrCodeSize"
      [errorCorrectionLevel]="'L'"
      [margin]="3"
      [allowEmptyString]="true"
      [elementType]="'canvas'"
      [imageSrc]="'assets/images/logo-qr-black.png'"
      [imageHeight]="logoSize"
      [imageWidth]="logoSize"
    ></qrcode>
  </div>
  <img class="h-[340px] w-[442px]" src="/assets/images/ffd-notes-sign-up-modal/ffd-notes-sign-up-modal.png" alt="Sign up" />
  <button class="absolute right-7 top-7 p-2" (click)="onCloseClick()">
    <svg-icon class="text-text-primary" key="px-24-x" size="md"></svg-icon>
  </button>
</div>
